import React from 'react';
import StatusTag from 'components/StatusTag';
import { getLicenseStatus } from 'shared/utils/license';

const LicenseStatusTag = ({ license }) => (
  <StatusTag status={getLicenseStatus(license)} />
);

export default LicenseStatusTag;
